module.exports = __webpack_public_path__ + "static/media/discount_icon.21018b9f.svg";